<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto d-flex flex-column justify-center align-center" v-if="cardList !== false && cardList.length == 0">
        <div class="text-center">
            <v-img src="@/assets/img/Matnhaye-amadeh.svg" aspect-ratio="16/9" max-width="600" class="mx-auto"></v-img>
            <h4 class="text-primary my-5 font-weight-bold">قالب‌های آماده</h4>
            <p class="text-grey-darken-1 text-meta my-4">قالب‌های از پیش آماده باعث افزایش سرعت ایجاد و حفظ یکپارچگی مطالب پایگاه دانش خواهند گردید.</p>
            <v-btn @click="$router.push({path: '/settings/knowledgebaseTemplate/new' })" color="primary" class="mt-1" ><v-icon class="me-1">add</v-icon>قالب جدید</v-btn>
        </div>
    </div>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto" v-else-if="cardList !== false">
        <v-col xl="4" lg="6" md="7" sm="9" cols="12">
            <p class="text-primary font-weight-bold mb-2">قالب‌های آماده</p>
            <p class="text-meta text-grey-darken-1">قالب‌های از پیش آماده باعث افزایش سرعت ایجاد و حفظ یکپارچگی مطالب پایگاه دانش خواهند گردید.</p>
            <v-btn v-if="$auth.user.full_admin || $auth.user.branch_admin" color="primary" class="workingShift-btn my-2" @click="$router.push({path: '/settings/knowledgebaseTemplate/new' })">
                <v-icon class="me-1">add</v-icon>قالب جدید
            </v-btn>
            <workingShiftCard
                :lists="cardList"
                @deleteCard="deleteList"
                icon="icon-From"
                @editCard="(id) => $router.push({path: `/settings/knowledgebaseTemplate/${id}`})"
                :showActions='{editable:$auth.user.full_admin || $auth.user.branch_admin,deletable:$auth.user.full_admin || $auth.user.branch_admin}'
                :showDetails="false"
            ></workingShiftCard>
        </v-col>
    </div>
</template>
<script>
export default {
    title: "قالب‌های آماده",
    validate(context) {
        return context.system.license.features.kb_core && context.rbac.can('manage knowledge base');
    },
    data() {
        return {
            cardList: false,
        };
    },
    methods: {
        async getKnowledgebaseTemplates() {
            await this.$knowledgebaseTemplateList().then((res) => {
                if (res && res.status == "OK") {
                    this.cardList = res.data;
                }
            });
        },
        async deleteList(id) {
            await this.$knowledgebaseTemplateDelete(id).then(async res=>{
                if(res && res.status == "DELETED"){
                    await this.getKnowledgebaseTemplates()
                    this.$toast.success(res.message);
                }

            })
        },
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            await this.getKnowledgebaseTemplates();
            this.$loading.finish();
        });
    },
};
</script>
